import React from "react";

import Content from "../components/Content";


const Learner: React.FC = () => {
    return(
        <Content type={"learner"}/>
    )
}

export default Learner;